// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"2450d972","43":"51f5c9be","131":"2450d972","3091":"311743ce","3677":"c09c4f99","5290":"78c0c2b9","8945":"c09c4f99"}[chunkId] + ".chunk.css";
};